import React, {Fragment} from 'react';
import {Button, Stack, Typography} from '@mui/material';

import {DataInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText, getAddressforMaps} from 'presentation/utils';
import {OdontoAddressSectionProps} from './types';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';

const {guideDetails} = translations['pt-br'].privateFlow.guideFlow;

export function OdontoAddressSection({provider}: OdontoAddressSectionProps) {
	const address = getAddressforMaps({
		address: provider.logradouro,
		complement: provider.complemento,
		district: provider.bairro,
		city: provider.cidade,
		state: provider.uf,
		zipCode: provider.cep,
		number: provider.numero,
	});

	const handleOpenGoogleMaps = () => openGoogleMaps(address.addressForMaps || '');

	return (
		<Stack gap={1}>
			<Typography variant="subtitle2" color="text.secondary">
				{guideDetails.address}
			</Typography>

			<Stack gap={1}>
				<DataInfo
					removeItemTextMargin
					removePaddingBottom
					iconName="location-on-filled"
					secondaryText={
						<Fragment>
							{address.formattedAddress}
							<br />
							{provider.pontoReferencia ? (
								<Fragment>
									<strong>{guideDetails.referencePoint}</strong>{' '}
									{formatText(provider.pontoReferencia)}
								</Fragment>
							) : null}
						</Fragment>
					}
					listItemProps={{
						sx: {
							width: 'unset',
							padding: 0,
						},
					}}
				/>
				<Button onClick={handleOpenGoogleMaps} variant="outlined">
					{guideDetails.viewMap}
				</Button>
			</Stack>
		</Stack>
	);
}
